export default {"src":"/_next/static/media/check.d9ae04c5.svg","height":20,"width":21};